import { Theme, ThemeLocations, Themes } from "@/shared/utils/theme/theme";

export const ThemesEasyModeApp = Themes.filter((theme) =>
  theme.location.includes(ThemeLocations.NEXT_APP),
);

export const ThemesLandingApp = Themes.filter((theme) =>
  theme.location.includes(ThemeLocations.LANDING_APP),
);

export const DefaultThemeIdLandingApp = Theme.dg.id;

export const DefaultThemeIdEasyModeApp = Theme.dm.id;
